import { createRoutine } from 'redux-saga-routines';
import { Action } from 'redux-actions';

import { genApiSchemaState } from 'src/utils/redux';
import { wrapWithNamespace } from './constants';
import { RegisterCompletionState } from './types';

export const registerCompletionAction = createRoutine(
    wrapWithNamespace('update'),
);

const initialState: RegisterCompletionState = genApiSchemaState({
    data: undefined,
    loading: false,
    isCompleted: false,
});

const updateRegisterCompletionReducer = (
    state = initialState,
    { type, payload }: Action<any>,
): RegisterCompletionState => {
    const handler = HANDLERS[type];
    return handler ? handler(state, payload) : state;
};

const handleTrigger = (state: RegisterCompletionState) => ({
    ...state,
    loading: true,
    isCompleted: false,
});

const handleSuccess = (state: RegisterCompletionState) => ({
    ...state,
    loading: false,
    isCompleted: true,
    error: {},
});

const handleError = (_: RegisterCompletionState, payload: any) => ({
    ...initialState,
    error: payload,
});

const HANDLERS = {
    [registerCompletionAction.TRIGGER]: handleTrigger,
    [registerCompletionAction.SUCCESS]: handleSuccess,
    [registerCompletionAction.FAILURE]: handleError,
};

export default updateRegisterCompletionReducer;
